<template>
    <div class="concierge-list">
        <div class="tags-container">
            <div class="tags" v-if="category.length > 1">
                <a v-for="item in category" v-bind:key="item.id" v-on:click="filterList(item.id)">{{item.name}}</a>
            </div>
        </div>

        <div class="text-1">{{company_name}} Concierge Sponsors</div>

        <div class="list">
            <div class="item" v-for="item in sortedList" v-bind:key="item.id">
                <div class="image" v-if="item.image">
                    <router-link v-if="item.linktype == 1" v-bind:to="'/' + item.id"><img v-bind:src="item.image.url" v-bind:width="item.image.width" v-bind:height="item.image.height" /></router-link>
                    <a v-else-if="(item.linktype == 2) && (item.contact.website.length > 0)" v-bind:href="item.contact.website" target="_blank" rel="nofollow" ><img v-bind:src="item.image.url" v-bind:width="item.image.width" v-bind:height="item.image.height" /></a>
                    <img v-else v-bind:src="item.image.url" v-bind:width="item.image.width" v-bind:height="item.image.height" />
                </div>
                <div class="text">
                    <div class="name">
                        <router-link v-if="item.linktype == 1" v-bind:to="'/' + item.id" >{{item.name}}</router-link>
                        <a v-else-if="(item.linktype == 2) && (item.contact.website.length > 0)" v-bind:href="item.contact.website" target="_blank" rel="nofollow" >{{item.name}}</a>
                        <span v-else>{{item.name}}</span>
                    </div>
                    <div class="addr">{{item.contact|addressFormat}}</div>
                    <div class="phone">{{item.contact.phone|phoneFormat}}</div>
                </div>

                <div class="buttons">
                    <a v-if="item.contact.website.length > 0" v-bind:href="item.contact.website" target="_blank" rel="nofollow" class="button">View Website</a>
                    <a v-if="item.contact.email.length > 0" v-bind:href="'mailto:' + item.contact.email" rel="nofollow" class="button">Send Email</a>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.concierge-list {
    padding-right: 50px;

    .tags-container {
        text-align: center;
        margin-bottom: 25px;
    }

    .tags {
        display: inline-block;
        padding: 20px 50px;
        text-align: center;
        border-radius: 15px;
        font-size: 20px;
        line-height: 26px;
        text-transform: uppercase;

        a {
            cursor: pointer;

            &:after {
                content: " | ";
            }

            &:last-child:after {
                content: "";
            }
        }
    }

    .text-1 {
        text-align: center;
        text-transform: uppercase;
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 10px;
    }

    .list {
        margin: 40px 0;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 300px));
        grid-gap: 38px;

        .item {
            display: grid;
            grid-template-areas: "image text"
                                 "buttons buttons";
            grid-template-columns: 100px auto;
            grid-gap: 20px;

            background-color: #fff;
            padding: 20px;
            font-size: 17px;
            line-height: 18px;

            .image {
                grid-area: image;
            }
            .text {
                grid-area: text;
            }

            .name {
                font-weight: bold;
                margin-bottom: 15px;
            }
            .addr {
                margin-bottom: 15px;
            }

            .buttons {
                grid-area: buttons;
                text-align: center;
            }

            .button {
                display: inline-block;
                padding: 10px;
                margin: 0 10px;
                font-size: 14px;
                line-height: 20px;
                border-radius: 5px;
            }
        }
    }
}

.concierge-content-mobile {
    .concierge-list {
        padding-right: 0px;
    }
    .tags-container, .text-1 {
        display: none;
    }
    .list {
        margin: 20px 0;
        grid-template-columns: repeat(auto-fit, minmax(320px, auto));
        grid-gap: 20px;
    }
}
</style>

<script>
import axios from 'axios'

const apiUrlList = window.bs_options.api + '/public/affiliate?company_id=' + window.bs_options.company_id

export default {
    name: 'list',
    data: function () {
        return {
            category: [],
            list: [],
            category_id: 0,
            company_name: ''
        }
    },
    mounted: function () {
        if (typeof window.bs_options === 'undefined') {
            alert('Undefined bs_options')
            return
        }

        this.company_name = window.bs_options.company_name

        this.loadList()
    },
    computed: {
        sortedList: function () {
            if (this.category_id === 0) {
                return this.list
            }

            let arList = []

            for (let index in this.list) {
                if (this.list[index].category.indexOf(this.category_id) !== -1) {
                    arList.push(this.list[index])
                }
            }

            return arList
        }
    },
    methods: {
        loadList: function () {
            axios.get(apiUrlList).then((response) => {
                if (response.status !== 200 || response.data.error) {
                    alert('Error')
                } else {
                    this.category = response.data.result.category
                    this.list = response.data.result.affiliate
                }
            }).catch(() => {
                alert('Error')
            })
        },
        filterList: function (categoryId) {
            this.category_id = parseInt(categoryId, 10)
        }
    }
}
</script>
